// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import classNames from "classnames"
// MUI
import { withStyles} from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import CloseIcon from "@material-ui/icons/Close"
import Typography from "@material-ui/core/Typography"
import grey from "@material-ui/core/colors/grey"

// LOGGING SETUP
import appConfig from "./../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashMessage>")

const styles = theme => {
    return {
        messageRoot: {
            position: "fixed",
            top: 0,
            left: 0,
//            background: "rgba(0,0,0,0.6)",
            background: theme.messageBackground,
            "z-index": 1000,
            width: "100%",
            height: "100%",
            //            display: "none",
            display: "flex",
            justifyContent: "center",
        },
        messagePaper: {
//            marginTop: "auto",
            //            marginBottom: "auto",
            margin: "auto",
            marginLeft: 20,
            marginRight: 20,
            padding: 0,
            height: 120,
            width: "90%",
            //
            // desktop - if more than 600
            //
            [theme.breakpoints.up("md")]: {
                width: 400,
            },
        },

        messageTextDiv: {
            display: "flex",
            margin: "auto",
            justifyContent: "flex-start",
            marginTop: -10,
            marginLeft: 20,
            marginRight: 20,
            marginBottom: 20,            
        }
    }
}

class FlashMessage extends Component {
    render() {
        const { classes, isVisible, variant, onDone } = this.props
        return (
            <div>
            { isVisible && variant === "nocontacts" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} ><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        Please select a representative
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}

            { isVisible && variant === "nostatements" && (
                <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} onClick={onDone}><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        Please select your statements
                      </div>
                    </Typography>
                  </div>
                </Paper>
                </div>
            )}

            { isVisible && variant === "additionalreson" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} onClick={onDone}><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        Please select an additional reason
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}

            { isVisible && variant === "norates" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} onClick={onDone}><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        Please rate reasons, maximum 100 points
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}


            { isVisible && variant === "invalidentry" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} ><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        {this.props.text}
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}

            { isVisible && variant === "zipformhelp" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}} onClick={onDone}><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        Please enter Zip Code so we can find your local representatives
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}
              

            { isVisible && variant === "generic" && (
              <div className={classes.messageRoot} onClick={onDone}>
                <Paper className={classes.messagePaper}>
                  <div style={{width: "100%", textAlign: "right", padding: 5}}><CloseIcon style={{color: grey[600]}}/></div>
                  <div className={classes.messageTextDiv}>
                    <Typography variant="h6">
                      <div>
                        {this.props.text}
                      </div>
                    </Typography>
                  </div>
                </Paper>
              </div>
            )}
              
              
              
            </div>
        )
    }
}

FlashMessage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(FlashMessage)
